import { useState, type FormEvent } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

export function LoginPage() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/" replace />;

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await login(email, password);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Erro ao fazer login');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="min-h-screen flex items-center justify-center p-4 relative overflow-hidden"
      style={{ background: 'var(--bg)' }}
    >
      {/* Glow decorativo de fundo (sutil) */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0"
        style={{
          background:
            'radial-gradient(ellipse 600px 400px at 85% 10%, var(--cyan-glow) 0%, transparent 60%), radial-gradient(ellipse 500px 350px at 15% 95%, rgba(102, 252, 241, 0.08) 0%, transparent 55%)',
        }}
      />

      <div className="w-full max-w-sm relative z-10">
        {/* Eyebrow + logo */}
        <div className="text-center mb-8">
          <p
            className="inline-flex items-center gap-2 mb-5"
            style={{
              fontFamily: "'JetBrains Mono', monospace",
              fontSize: '10px',
              color: 'var(--cyan)',
              letterSpacing: '0.2em',
              textTransform: 'uppercase',
            }}
          >
            <span
              aria-hidden="true"
              style={{ width: 24, height: 1, background: 'var(--cyan)' }}
            />
            Área de acesso
          </p>
          <img
            src="/logos/logo-color.webp"
            alt="DocAds"
            className="h-10 w-auto mx-auto mb-4"
            width={160}
            height={40}
          />
          <h1
            className="text-2xl"
            style={{
              fontFamily: "'Poppins', sans-serif",
              fontWeight: 800,
              color: 'var(--text)',
              letterSpacing: '-0.01em',
            }}
          >
            Marketing de <span style={{ color: 'var(--cyan)' }}>performance</span>
          </h1>
          <p
            className="mt-2 text-sm"
            style={{ color: 'var(--text-mid)' }}
          >
            Rastreamento de leads WhatsApp
          </p>
        </div>

        <form
          onSubmit={handleSubmit}
          className="space-y-4"
          style={{
            background: 'var(--surface)',
            border: '1px solid var(--border)',
            borderRadius: 14,
            padding: 24,
          }}
        >
          {error && (
            <div
              role="alert"
              aria-live="assertive"
              className="rounded-lg p-3 text-sm"
              style={{
                background: 'var(--danger-soft)',
                border: '1px solid rgba(248, 113, 113, 0.24)',
                color: 'var(--danger)',
              }}
            >
              {error}
            </div>
          )}

          <div>
            <label className="ds-label" htmlFor="login-email">Email</label>
            <input
              id="login-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="ds-input"
              placeholder="seu@email.com"
              required
              autoComplete="email"
            />
          </div>

          <div>
            <label className="ds-label" htmlFor="login-password">Senha</label>
            <input
              id="login-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="ds-input"
              placeholder="••••••••"
              required
              autoComplete="current-password"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="ds-btn ds-btn-primary w-full justify-center"
            style={{ padding: '11px 18px' }}
          >
            {loading ? 'Entrando...' : 'Entrar'}
          </button>
        </form>

        <p
          className="text-center mt-6"
          style={{
            fontFamily: "'JetBrains Mono', monospace",
            fontSize: 10,
            letterSpacing: '0.1em',
            textTransform: 'uppercase',
            color: 'var(--text-dim)',
          }}
        >
          DocAds Tracker · v1
        </p>
      </div>
    </div>
  );
}
